<template>
<!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista login, permite autenticarse para tener acceso en el portal
    * Autor: 
    * F.Creación: 
  -->
  <layout>
    <!-- Contenido -->
    <template v-slot:content>
      <v-content>
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
              <v-card class="elevation-12">
                <v-toolbar color="primary" dark flat>
                  <v-toolbar-title>{{$t('signin')}}</v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-card-title class="title">
                  <v-img :src="require('@/assets/main_logo.png')" class="logo"></v-img>
                </v-card-title>
                <v-card-actions>
                  <!--<v-btn color="primary outline" v-on:click="shiftLocale">{{$t('close-action')}}</v-btn>-->
                  <v-spacer />
                  <v-btn color="primary" v-on:click="sigin">{{$t('login')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-snackbar v-model="snackbar">
            {{ mensaje }}
            <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
          <v-dialog v-model="isLoading" hide-overlay persistent width="300">
            <v-card color="secundary" dark>
              <v-card-text>
                Validando credenciales por favor espera
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-container>
      </v-content>
    </template>
  </layout>
</template>

<script>
// Utilities
import { mapGetters } from "vuex";

import i18nMessages from "./i18n.messages";
import Layout from "@/components/Layouts/Anonymous";
import { Auth, Hub } from "aws-amplify";

// Variable global
// el objetivo de la vairable self es "suplantar"
// la referencia "this", ya que existen alguno contextos
// en lo que "this" no está disponible
var self = null;

export default {
  i18n: i18nMessages,
  components: {
    layout: Layout
  },
  created() {
    self = this;
    this.$i18n.locale = this.locale;
    // Listener que detecta el cambio de autenticacion
      Hub.listen("auth", (data) => {
        switch (data.payload.event) {
          case "signIn":
            // Obtiene el nombre del usuario logueado
            Auth.currentAuthenticatedUser().then(data => {
              // Obtiene el email de usuario
              let email = data.signInUserSession.idToken.payload.email;
              // Ontiene Los perfiles del usuario
              let settings = {
                email: email
              };
              this.$GET('/api/users/email/{{email}}', settings)
              .then(data => {
                // Busca el perfil de acceso al portal
                let user = data.userProfiles.find(profile => profile.profileId === 2 || profile.profileId === 5 || profile.profileId === 6 || profile.profileId === 7 || profile.profileId === 9);
                if(user){
                  this.$store.dispatch("setUserProfile", { userProfile: data }).then(() => {
                    window.location.reload(true);
                    console.log('Session!!!!!!! Usuario autorizado');
                  });
                } else{
                  // Usuario no autorizado al portal, cierre de sesion
                  this.$store.dispatch("signOut").then(()=> {
                    console.log('Session!!!!!!! Usuario no autorizado');
                  });
                }
              })
              .catch(e => {
                console.log(e)
              });
            });
            break;
          case 'signIn_failure':
            console.log('the user failed to sign in');
            console.log('the error is', data.payload);
            // TODO: Mostrar mensaje de error al usuario
            break;
          case "signOut":
            console.log(`Sign out`, data.payload.data);
            this.$store.dispatch("updateSession").then(() => {
              this.$router.push({ path: "/" });
            });
            break;
          case "customOAuthState":
            console.log(`customOAuthState`, data.payload.data);
        }
      });
  },
  beforeDestroy() {},
  data: () => ({
    snackbar: false,
    mensaje: "",
  }),
  mounted: () => {
    if (self.isSignedIn) {
      self.$router.push("/");
    }
  },
  computed: {
    ...mapGetters(["isLoading", "locale", "isSignedIn"])
  },
  methods: {
    shiftLocale() {
      this.$store.dispatch("shiftLocale");
    },
    // Inicio con ADFS
    async sigin(){
      // Se llama al metodo Federado;
      Auth.federatedSignIn({provider: process.env.VUE_APP_OAUTH_PROVIDER || ""});
    }
  },
  watch: {
    locale(value) {
      self.$i18n.locale = value;
    }
  }
};
</script>

<style scoped>
.title{
  color: var(--v-primary-base);
}
.logo{
  width: 50%;
  margin: 10px;
}
</style>